'use strict';

import time from '../time/time';
import DataItem from './data-item';

export default class DurationDataItem extends DataItem {
  constructor(appName) {
    super({
      duration: Math.floor(time.appLoadTime(appName))
    });
    this.appName = appName;
  }

  setFirstRequestDuration() {
    this.data.frd = Math.floor(time.firstRequestDuration(this.appName));
    return this;
  }
}



// WEBPACK FOOTER //
// ./data-items/duration-item.js